<template>
 <div name="Active" v-if="active" style="width:30%">
      <h4>你已經成功完成國立勤益科技大學【產運處報名暨繳費系統】帳號啟用</h4>
      <h4>請點擊以下網址登入你的帳戶</h4>
      <span class="nav-link active bg-info text-white rounded">
        <router-link to="/">登入</router-link>
          </span>
    </div>

</template>


<script>
import * as tools from '../tool'
export default {
  name: 'Active',
     data () {
    return {
        active: 0,
        num:'',
      isIE: false,
      inputData: null,
    }
  },

  created () {
    console.log('======created searchView =====');
    this.isIE = navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1 || navigator.userAgent.indexOf("Edge") > -1;
 this.num = this.$route.query.num;
    let vm = this;


    this.$http
     .get("./WebApi/ociaRep/PutociaRepActiveCode/".concat(this.num))
    .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data;
            vm.active = true ;
            console.log(vm.inputData);

          }
        })
        .catch(function (error) {
          tools.showAlert(vm.inputData, 'danger', '網路連線失敗' + error);
        });

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
